import React from "react";
import { useTheme } from "@bookingcom/bui-react";
import { t } from "@bookingcom/lingojs-core";
import { useI18n } from "@bookingcom/lingojs-react";
import TooManyFiltersIllustration from "../../../../assets/illustrations/too-many-filters.svg";
import Frame from "../../Frame/index.js";
export const TooManyFilters = () => {
    const theme = useTheme();
    const i18n = useI18n();
    return (React.createElement(Frame, { justifyContent: "center" },
        React.createElement(Frame, { attributes: {
                style: {
                    ...theme.fonts.small.font_emphasized_2,
                    color: theme.colors.color_foreground_alt,
                    textAlign: "center"
                }
            }, m: 4 }, i18n.trans(t("flights_filter_error_no_results"))),
        React.createElement(Frame, { grow: 1, m: 4 },
            React.createElement(Frame, null,
                React.createElement(TooManyFiltersIllustration, { style: { maxHeight: "300px" } })))));
};
